import { render, staticRenderFns } from "./wechatLabel.vue?vue&type=template&id=6dc46416&scoped=true"
import script from "./wechatLabel.vue?vue&type=script&lang=js"
export * from "./wechatLabel.vue?vue&type=script&lang=js"
import style0 from "./wechatLabel.vue?vue&type=style&index=0&id=6dc46416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc46416",
  null
  
)

export default component.exports